import { showModal } from "../utils/modalUtils";
import { showToast } from "./toast";
import {trans} from "../i18n/i18n";
import {Toast} from "../consts/toast";
import { setDefaultCard, deleteCard } from "../api/billing";

document.addEventListener('DOMContentLoaded', initializeCreditCardSettings);

/**
 * Initializes event listeners for credit card settings.
 */
function initializeCreditCardSettings() {
    const creditCardSettings = document.getElementById("credit-cards-settings");
    if (!creditCardSettings) {
        return;
    }

    const defaultPaymentCardActions = document.querySelectorAll('.js-make-default-payment-card');
    const removePaymentCardActions = document.querySelectorAll('.js-remove-payment-card');
    const addNewCardActions = document.querySelectorAll('.js-add-payment-card');

    defaultPaymentCardActions.forEach(link => {
        link.addEventListener('click', handleMakeDefaultPaymentCard);
    });

    removePaymentCardActions.forEach(btn => {
        btn.addEventListener('click', handleRemovePaymentCard);
    });

    addNewCardActions.forEach(btn => {
        btn.addEventListener('click', handleAddNewCard)
    })
}

/**
 * Handles setting a payment card as the default.
 * @param {Event} event - The event triggered by clicking the "Make default" button.
 */
function handleMakeDefaultPaymentCard(event) {
    event.preventDefault();
    const cardId = event.currentTarget.dataset.cardId;
    const creditCardInfoElement = event.currentTarget.closest('.credit-card-info');

    if (!creditCardInfoElement) {
        console.error('Parent .credit-card-info element not found.');
        return;
    }

    const cardDetailsElement = creditCardInfoElement.querySelector('.credit-card-number');
    const cardExpiryElement = creditCardInfoElement.querySelector('.credit-card-expiration');

    if (cardDetailsElement && cardExpiryElement) {
        const cardDetails = cardDetailsElement.innerText;
        const cardExpiry = cardExpiryElement.innerText;

        const message = `Are you sure you want to set the payment card with numbers <strong>${cardDetails}</strong> and expiration date <strong>${cardExpiry}</strong> as the <strong>default payment card?</strong>`;
        const title = "Set Default Payment Card";
        showModal(message, async () => {
            toggleLoadingOverlay(true);
            try {
                const data = await setDefaultCard(cardId);
                updateCreditCardSection(data.cardsHtml);
                showToast(trans('Successfully set as default.'), Toast.SUCCESS);
            } finally {
                toggleLoadingOverlay(false);
            }
        }, title);
    } else {
        if (!cardDetailsElement) console.error('Card details element not found.');
        if (!cardExpiryElement) console.error('Card expiry element not found.');
    }
}

/**
 * Handles removing a payment card.
 * @param {Event} event - The event triggered by clicking the "Remove" button.
 */
function handleRemovePaymentCard(event) {
    event.preventDefault();
    const cardId = event.currentTarget.dataset.cardId;
    const creditCardInfoElement = event.currentTarget.closest('.credit-card-info');

    if (!creditCardInfoElement) {
        console.error('Parent .credit-card-info element not found.');
        return;
    }

    const cardDetailsElement = creditCardInfoElement.querySelector('.credit-card-number');
    const cardExpiryElement = creditCardInfoElement.querySelector('.credit-card-expiration');

    if (cardDetailsElement && cardExpiryElement) {
        const cardDetails = cardDetailsElement.innerText;
        const cardExpiry = cardExpiryElement.innerText;

        const message = `Are you sure you want to <strong>remove</strong> the payment card ending in <strong>${cardDetails}</strong> and with expiration date <strong>${cardExpiry}</strong>? This action cannot be undone.`;
        const title = "Remove Payment Card";
        showModal(message, async () => {
            toggleLoadingOverlay(true);
            try {
                const data = await deleteCard(cardId);
                updateCreditCardSection(data.cardsHtml);
                showToast(trans('Successfully removed.'), Toast.SUCCESS);
            } finally {
                toggleLoadingOverlay(false);
            }
        }, title);
    } else {
        if (!cardDetailsElement) console.error('Card details element not found.');
        if (!cardExpiryElement) console.error('Card expiry element not found.');
    }
}

function handleAddNewCard(event) {
    const billingComponent = document.getElementById('billing-address-vue');
    if (billingComponent && billingComponent.getElementsByClassName("address-box selected").length === 0) {
        event.preventDefault();
        showModal(trans("You must add a billing address before adding a payment card."), null, trans("Missing billing address"));
    }
}

/**
 * Updates the credit card section with new HTML content.
 * @param {string} cardsHtml - The new HTML content for the credit card section.
 */
function updateCreditCardSection(cardsHtml) {
    const creditCardSettings = document.getElementById('credit-cards-settings');
    creditCardSettings.parentElement.insertAdjacentHTML('beforeend', cardsHtml);
    creditCardSettings.remove();
    initializeCreditCardSettings(); // Reinitialize event listeners
}

/**
 * Toggles the visibility of the loading overlay.
 * @param {boolean} show - If true, the loading overlay will be shown. If false, it will be hidden.
 */
function toggleLoadingOverlay(show) {
    const creditCardsSettings = document.querySelector('#credit-cards-settings');
    const loadingOverlay = creditCardsSettings.querySelector('.loading-overlay');
    if (loadingOverlay) {
        if (show) {
            loadingOverlay.classList.remove('d-none');
        } else {
            loadingOverlay.classList.add('d-none');
        }
    }
}
